import { Box, Button } from '@factorialco/deprecated-design-system'
import { Maybe } from 'generated/resources/graphql'

import { IProjectWorkersPanelData } from '../../types'
import ProjectEmployeePopoverMenuList from '../PopoverMenuList'

export interface ActionButtonsProps {
  id: number
  employeeId: number
  assigned: boolean
  imputedMinutes: Maybe<number> | undefined
  laborCostCents: Maybe<number> | undefined
  laborCostCurrency: string
  employeeAccessAvatar: Maybe<string> | undefined
  employeeFullName: Maybe<string> | undefined
  canAssignSingleEmployee: boolean
  canSeeLaborCosts: boolean
  showProjectWorkersPanel: (values: IProjectWorkersPanelData) => void
}

const ActionButtons = ({
  id,
  employeeId,
  assigned,
  imputedMinutes,
  laborCostCents,
  laborCostCurrency,
  employeeAccessAvatar,
  employeeFullName,
  canAssignSingleEmployee,
  canSeeLaborCosts,
  showProjectWorkersPanel,
}: ActionButtonsProps) => {
  return (
    <Box flexDirection="row" gap="s8" justifyContent="flexEnd" paddingRight="s24">
      <ProjectEmployeePopoverMenuList
        employeeId={employeeId}
        assigned={assigned}
        projectWorkerId={id}
        canAssignSingleEmployee={canAssignSingleEmployee}
      />
      {canSeeLaborCosts && (
        <Button
          type="secondary"
          disabled={!laborCostCents}
          onClick={() => {
            showProjectWorkersPanel({
              projectWorkerId: id,
              employeeAccessAvatar,
              employeeFullName,
              imputedMinutes,
              laborCostCents,
              laborCostCurrency,
            })
            // track(trackingEvents.projectManagement.subprojects.openSubprojectDetails, {
            //   project_id: id,
            // })
          }}
          iconName="arrow-right"
        />
      )}
    </Box>
  )
}

export default ActionButtons
